export default "__VITE_ASSET__924a15fc__"